var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isOpen
    ? _c(
        "dialog",
        {
          ref: "sheetModal",
          staticClass: "sheet-modal",
          attrs: { id: "sheet-modal" },
          on: { close: _vm.closeModal },
        },
        [
          _c("div", { staticClass: "sheet-modal__header" }, [
            _c(
              "button",
              {
                staticClass: "sheet-modal__exit-button",
                on: {
                  click: function ($event) {
                    return _vm.closeModal()
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      "stroke-width": "1.5",
                      stroke: "currentColor",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M15.75 19.5 8.25 12l7.5-7.5",
                      },
                    }),
                  ]
                ),
                _vm._v("\n      Exit\n    "),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "sheet-modal__title",
                class:
                  _vm.totalQuantity < _vm.item.metaData.maxItems &&
                  "sheet-modal__title--warning",
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.totalQuantity < _vm.item.metaData.maxItems
                        ? `Fill your sheet ${_vm.totalQuantity}/${_vm.item.metaData.maxItems}`
                        : "Edit Sheet"
                    ) +
                    "\n    "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sheet-modal__content" }, [
            _vm.item.metaData.url &&
            _vm.totalQuantity < _vm.item.metaData.maxItems
              ? _c(
                  "button",
                  {
                    staticClass: "button button--secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.addDesign },
                  },
                  [_vm._v("\n      Add another design to this sheet\n    ")]
                )
              : _vm.totalQuantity >= _vm.item.metaData.maxItems
              ? _c("p", { staticClass: "sheet-modal__topper-success" }, [
                  _vm._v("\n      Nice, you've filled your sheet!\n    "),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "sheet-modal__items" },
              _vm._l(_vm.designs, function (design) {
                return _c("li", { staticClass: "sheet-modal__item" }, [
                  _c("img", { attrs: { src: design.thumbnail, alt: "" } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "sheet-modal__item-inner" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "button",
                          {
                            staticClass: "sheet-modal__edit",
                            on: {
                              click: function ($event) {
                                return _vm.editDesign(design)
                              },
                            },
                          },
                          [_vm._v("\n              Edit\n            ")]
                        ),
                        _vm._v(" "),
                        _vm.designs.length > 1
                          ? _c("button", {
                              staticClass: "close-button",
                              attrs: { "aria-label": "Remove design" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeDesign(design)
                                },
                              },
                            })
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("Quantity", {
                        attrs: {
                          value: design.quantity,
                          max: design.maxQuantity,
                        },
                        on: {
                          change: (quantity) => (design.quantity = quantity),
                        },
                      }),
                      _vm._v(" "),
                      _vm.totalQuantity < _vm.item.metaData.maxItems
                        ? _c(
                            "button",
                            {
                              staticClass: "sheet-modal__fill",
                              on: {
                                click: function ($event) {
                                  design.quantity = design.maxQuantity
                                },
                              },
                            },
                            [_vm._v("\n            Fill Sheet\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sheet-modal__footer" }, [
            _c("p", { staticClass: "sheet-modal__price" }, [
              _vm._v("\n      " + _vm._s(_vm.item.price) + "\n    "),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button sheet-modal__button",
                class:
                  _vm.totalQuantity > 0
                    ? "button--primary"
                    : "button--disabled",
                attrs: { disabled: _vm.totalQuantity === 0 },
                on: { click: _vm.updateSheet },
              },
              [_vm._v("\n      Update Sheet\n    ")]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }